import script from "./Messages.vue?vue&type=script&lang=ts&setup=true"
export * from "./Messages.vue?vue&type=script&lang=ts&setup=true"

import "./Messages.vue?vue&type=style&index=0&id=1d53d106&lang=scss"

const __exports__ = script;

export default __exports__